module.exports = __webpack_public_path__ + "static/pattern-01cf78a72946b82109c4f6777c53a4ab.svg";